<div
  [ngClass]="backgroundColor"
  class="grid rounded-xl overflow-hidden min-h-screen grid-cols-1 grid-rows-[1fr_auto_1fr] lg:grid-cols-[max(50%,36rem)_1fr]"
  >
  <header
    class="mx-auto w-full max-w-7xl px-6 pt-6 sm:pt-10 lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:px-8"
    >
    <div class="flex justify-start">
      @switch (logo.type) {
        @case ('image') {
          <img
            [alt]="logo.alt || appName + ' Logo'"
            [ngClass]="logo.class || 'h-12 '"
            [src]="logo.src"
            />
        }
        @case ('svg') {
          <div
        [innerHTML]="
          logo.svgContent || 'https://angular.io/assets/images/logos/angular/angular.svg'
        "
            [ngClass]="logo.class || 'h-12'"
          ></div>
        }
        @default {
          <div [ngClass]="logo.class || 'h-12'">
            <svg
              class="size-6"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              >
              <path
                d="M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
            </svg>
          </div>
        }
      }
    </div>
  </header>

  <main
    class="mx-auto w-full max-w-7xl px-6 py-24 sm:py-32 lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:px-8"
    >
    <div class="max-w-lg">
      <p [ngClass]="primaryColor" class="text-base font-semibold">404</p>
      <h1 class="mt-4 text-5xl font-semibold tracking-tight text-gray-900 sm:text-6xl">
        {{ 'common.notFound.pageNotFound' | translate }}
      </h1>
      <p class="mt-6 text-lg font-medium text-gray-500 sm:text-xl">
        {{ 'common.notFound.sorry' | translate }}
      </p>
      <div class="mt-10">
        <a [ngClass]="primaryColor" [routerLink]="['/dashboard']" class="text-sm font-semibold">
          <span aria-hidden="true" class="pi pi-arrow-left"></span>
          {{ 'common.notFound.backToHome' | translate }}
        </a>
      </div>
    </div>
  </main>

  <div class="hidden lg:relative lg:col-start-2 lg:row-start-1 lg:row-end-4 lg:block">
    <img
      alt="Decorative"
      class="absolute inset-0 h-full w-full object-cover"
      src="https://images.unsplash.com/photo-1470847355775-e0e3c35a9a2c?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1825&q=80"
      />
  </div>
</div>
